/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from '../ba-supplier-ui.constants';
import { Observable } from 'rxjs';
import { Conditional } from '@angular/compiler';
// import { URLSearchParams } from '@angular/http/src/url_search_params';
// import { RequestOptions } from '@angular/http/src/base_request_options';

@Injectable()
export class HierarchyService {

  private getHierarchyURL = Constants.API_SUP_URL + 'hierarchy/getHierarchy';
  private setHierarchyURL = Constants.API_SUP_URL + 'hierarchy/setHierarchy';
  private removeHierarchyURL = Constants.API_SUP_URL + 'hierarchy/deleteHierarchy';
  private getExistingUserHierarchyURL = Constants.API_SUP_URL + 'hierarchy/getUserHierarchy';

  constructor(private http: HttpClient) { }

  getData() : Observable<any> {
    return this.http.get<any>(this.getHierarchyURL);
  }

  setData(data:any) : Observable<any>{ 
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let hierarchyObervable = this.http.post(this.setHierarchyURL, data);
    return hierarchyObervable;
  }

  getExistingUserHierarchy(userId: any): Observable<any>{
    let queryParams = new HttpParams();
    queryParams = queryParams.append("userId", userId);
    return this.http.get<any>(this.getExistingUserHierarchyURL, { params: queryParams});
  }

  removeMapping(data:any) : Observable<any>{
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.removeHierarchyURL, data);
    
  }
}

